import {
    maxLength,
    minLength,
    required,
    sameAs,
} from 'vuelidate/lib/validators';

export const passwordValidation = {
    required,
    minLength: minLength(10),
    maxLength: maxLength(128),
    characteristics: (value: string): boolean => {
        return value.length
            ? [
                  /[A-Z]/.test(value),
                  /[a-z]/.test(value),
                  /[0-9]/.test(value),
                  /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(value),
              ].filter((booleanValue) => booleanValue === true).length > 2
            : true;
    },
    repeatedChars: (value: string): boolean => {
        return value.length ? /^(?!.*(.)\1{2,}).+$/.test(value) : true;
    },
};

export default {
    password: {
        ...passwordValidation,
    },
    passwordAgain: {
        required,
        sameAs: sameAs('password'),
    },
};
